/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Italicize_Selected_EventsInputs */

const en_italicize_selected_events = /** @type {(inputs: Italicize_Selected_EventsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Italicize selected events`)
};

const fr_italicize_selected_events = /** @type {(inputs: Italicize_Selected_EventsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mettre en italique les événements sélectionnés`)
};

const de_italicize_selected_events = /** @type {(inputs: Italicize_Selected_EventsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ausgewählte Ereignisse kursiv darstellen`)
};

const it_italicize_selected_events = /** @type {(inputs: Italicize_Selected_EventsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Metti in corsivo gli eventi selezionati`)
};

const ru_italicize_selected_events = /** @type {(inputs: Italicize_Selected_EventsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Выделить курсивом выбранные события`)
};

const es_italicize_selected_events = /** @type {(inputs: Italicize_Selected_EventsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Poner en cursiva los eventos seleccionados`)
};

const zh_cn2_italicize_selected_events = /** @type {(inputs: Italicize_Selected_EventsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`将选定事件用斜体显示`)
};

const ja_italicize_selected_events = /** @type {(inputs: Italicize_Selected_EventsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`選択したイベントを斜体にする`)
};

const hi_italicize_selected_events = /** @type {(inputs: Italicize_Selected_EventsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`चुनिंदा घटनाओं को इटैलिक में लिखें`)
};

const pt_pt2_italicize_selected_events = /** @type {(inputs: Italicize_Selected_EventsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Destaque os eventos selecionados em itálico`)
};

/**
* | output |
* | --- |
* | "Italicize selected events" |
*
* @param {Italicize_Selected_EventsInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const italicize_selected_events = /** @type {((inputs?: Italicize_Selected_EventsInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Italicize_Selected_EventsInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_italicize_selected_events(inputs)
	if (locale === "de") return de_italicize_selected_events(inputs)
	if (locale === "it") return it_italicize_selected_events(inputs)
	if (locale === "ru") return ru_italicize_selected_events(inputs)
	if (locale === "es") return es_italicize_selected_events(inputs)
	if (locale === "zh-CN") return zh_cn2_italicize_selected_events(inputs)
	if (locale === "ja") return ja_italicize_selected_events(inputs)
	if (locale === "hi") return hi_italicize_selected_events(inputs)
	if (locale === "pt-PT") return pt_pt2_italicize_selected_events(inputs)
	return en_italicize_selected_events(inputs)
});